import { sprite, type SpriteDef } from './types';

// Classic symbol sprites: 32×32, 1-px ink outline, light from top-left.
// Key: '.' transparent, 'o' ink outline, others per sprite.

export const plum = sprite(
  'sym_plum',
  { o: 'ink', a: 'mud', b: 'leaf', c: 'forest', d: 'clover', e: 'brick', f: 'lavender', g: 'violet', h: 'pinkLilac', i: 'purple', j: 'aubergine' },
  [
    '................................',
    '................................',
    '...............o....ooooooo.....',
    '..............oao..obbbbbbco....',
    '..............oao.obdddddco.....',
    '..............oeaobdddddco......',
    '..............oeocdddccco.......',
    '..............oeaocccooo........',
    '...........oooooooooo...........',
    '.........ooffffooggggoo.........',
    '........ofhhhhffffgggggo........',
    '.......ohhhhhhffffgggggio.......',
    '......ohhhhhhffffgggggggio......',
    '.....ofhhhhhhffffgggggggiio.....',
    '.....ofhhhhiffffggggggggiio.....',
    '....offhhffifffggggggggiiiio....',
    '....offffffiffgggggggggiiiio....',
    '....offffffifgggggggggiiiiio....',
    '....ogfffffigggggggggiiiiiio....',
    '....oggggggigggggggggiiiiijo....',
    '....oggggggiggggggggiiiiiijo....',
    '....oggggggiggggggiiiiiiijjo....',
    '....ogggggggiggggiiiiiiijjjo....',
    '.....oggggggiggiiiiiiiijjjo.....',
    '.....oigggggiiiiiiiiiijjjjo.....',
    '......oiiiiiiiiiiiiiijjjjo......',
    '.......oiiiiiiiiiiijjjjjo.......',
    '........oiiiiiiiijjjjjjo........',
    '.........oojjjjjjjjjjoo.........',
    '...........oooooooooo...........',
    '................................',
    '................................',
  ],
);

export const bell = sprite(
  'sym_bell',
  { o: 'ink', a: 'gold', b: 'amber', c: 'lemon', d: 'brass', e: 'orange', f: 'bronze' },
  [
    '................................',
    '................................',
    '..............oooo..............',
    '.............oaaabo.............',
    '.............ocaaao.............',
    '............oaaaabbo............',
    '.............oooooo.............',
    '...........ooaaaaaaoo...........',
    '..........oaaaaaaaaaao..........',
    '.........occaaaaaaaaabo.........',
    '........oaccaaaaaaaaabbo........',
    '........oaccaaaaaaaaabbo........',
    '........oaccaaaaaaaaabbo........',
    '.......odaccaaaaaaaaabbeo.......',
    '.......odaccaaaaaaaaabbeo.......',
    '.......odaccaaaaaaaaabbeo.......',
    '.......odaccaaaaaaaaabbeo.......',
    '......oddaccaaaaaaaaabbeeo......',
    '......oddaccaaaaaaaaabbeeo......',
    '.....odddaaaaaaaaaaaabbeeeo.....',
    '....oddddaaaaaaaaaaaabbeeeeo....',
    '...oddddddddddddddddddddddddo...',
    '..oooooooooooooooooooooooooooo..',
    '.oddddddddddddddddddbbbbeeeeeeo.',
    '.obbbbbbbbbbbbbbbbbbbbbbeeeeeeo.',
    '..oooooooooooooooooooooooooooo..',
    '............oddddffo............',
    '............odddfffo............',
    '.............offffo.............',
    '..............oooo..............',
    '................................',
    '................................',
  ],
);

export const bar = sprite(
  'sym_bar',
  { o: 'ink', a: 'indigo', b: 'gold', c: 'navy', d: 'white', e: 'amber', f: 'steel' },
  [
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '....oooooooooooooooooooooooo....',
    '...oaaaaaaaaaaaaaaaaaaaaaaaoo...',
    '..oabbbbbbbbbbbbbbbbbbbbbbbboo..',
    '.oabcddddccccccddccccddddccceoo.',
    '.oabcddddccccccddccccddddccceoo.',
    '.oabcddccddccddccddccddccddceoo.',
    '.oabcddccddccddccddccddccddceoo.',
    '.oabcddddccccddddddccddddccceoo.',
    '.oabcddddccccddddddccddddccceoo.',
    '.oabcddccddccddccddccddccddceoo.',
    '.oabcddccddccddccddccddccddceoo.',
    '.oabcddddccccddccddccddccddceoo.',
    '.oobcffffccccffccffccffccffceoo.',
    '..ooeeeeeeeeeeeeeeeeeeeeeeeeoo..',
    '...oooooooooooooooooooooooooo...',
    '....oooooooooooooooooooooooo....',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
  ],
);

export const bar2 = sprite(
  'sym_bar2',
  { o: 'ink', a: 'indigo', b: 'gold', c: 'navy', d: 'amber', e: 'white' },
  [
    '................................',
    '................................',
    '................................',
    '......oooooooooooooooooooo......',
    '.....oaaaaaaaaaaaaaaaaaaaoo.....',
    '....oabbbbbbbbbbbbbbbbbbbboo....',
    '...oabccccccccccccccccccccdoo...',
    '...oabcccceecccecceeccccccdoo...',
    '...oabccccececececececccccdoo...',
    '...oabcccceecceeeceeccccccdoo...',
    '...oabccccececececececccccdoo...',
    '...oabcccceeccececececccccdoo...',
    '...oobccccccccccccccccccccdoo...',
    '....ooddddddddddddddddddddoo....',
    '.....oooooooooooooooooooooo.....',
    '......oooooooooooooooooooo......',
    '......oooooooooooooooooooo......',
    '.....oaaaaaaaaaaaaaaaaaaaoo.....',
    '....oabbbbbbbbbbbbbbbbbbbboo....',
    '...oabccccccccccccccccccccdoo...',
    '...oabcccceecccecceeccccccdoo...',
    '...oabccccececececececccccdoo...',
    '...oabcccceecceeeceeccccccdoo...',
    '...oabccccececececececccccdoo...',
    '...oabcccceeccececececccccdoo...',
    '...oobccccccccccccccccccccdoo...',
    '....ooddddddddddddddddddddoo....',
    '.....oooooooooooooooooooooo.....',
    '......oooooooooooooooooooo......',
    '................................',
    '................................',
    '................................',
  ],
);

export const bar3 = sprite(
  'sym_bar3',
  { o: 'ink', a: 'indigo', b: 'gold', c: 'navy', d: 'white', e: 'amber' },
  [
    '................................',
    '......oooooooooooooooooooo......',
    '.....oaaaaaaaaaaaaaaaaaaaoo.....',
    '....oabbbbbbbbbbbbbbbbbbbboo....',
    '...oabccccddcccdccddcccccceoo...',
    '...oabccccdcdcdcdcdcdccccceoo...',
    '...oabccccddccdddcddcccccceoo...',
    '...oabccccdcdcdcdcdcdccccceoo...',
    '...oobccccddccdcdcdcdccccceoo...',
    '....ooeeeeeeeeeeeeeeeeeeeeoo....',
    '.....oooooooooooooooooooooo.....',
    '......oooooooooooooooooooo......',
    '.....oaaaaaaaaaaaaaaaaaaaoo.....',
    '....oabbbbbbbbbbbbbbbbbbbboo....',
    '...oabccccddcccdccddcccccceoo...',
    '...oabccccdcdcdcdcdcdccccceoo...',
    '...oabccccddccdddcddcccccceoo...',
    '...oabccccdcdcdcdcdcdccccceoo...',
    '...oobccccddccdcdcdcdccccceoo...',
    '....ooeeeeeeeeeeeeeeeeeeeeoo....',
    '.....oooooooooooooooooooooo.....',
    '......oooooooooooooooooooo......',
    '.....oaaaaaaaaaaaaaaaaaaaoo.....',
    '....oabbbbbbbbbbbbbbbbbbbboo....',
    '...oabccccddcccdccddcccccceoo...',
    '...oabccccdcdcdcdcdcdccccceoo...',
    '...oabccccddccdddcddcccccceoo...',
    '...oabccccdcdcdcdcdcdccccceoo...',
    '...oobccccddccdcdcdcdccccceoo...',
    '....ooeeeeeeeeeeeeeeeeeeeeoo....',
    '.....oooooooooooooooooooooo.....',
    '......oooooooooooooooooooo......',
  ],
);

export const coin = sprite(
  'sym_coin',
  { o: 'ink', a: 'brass', b: 'gold', c: 'amber', d: 'white', e: 'lemon', f: 'orange' },
  [
    '................................',
    '................................',
    '............oooooooo............',
    '..........ooaaaabbbboo..........',
    '........ooaaaaaaabbbbboo........',
    '.......oaaaaaaaaaabbbbbbo.......',
    '......oaaaaaccccccccbbbbco......',
    '.....oaaadcccbbbbbbcccbbbco.....',
    '....oaaadccbbbbbbbbbbccbbcco....',
    '....oaadccbbbbbbbbbbbbeebcco....',
    '...oaaaccbbbbbbbbbbbbbbeeccco...',
    '...oaaacbbbbbbbbbbbbbbbbeccco...',
    '..obaaccbbbbbbbecbbbbbbbeeccfo..',
    '..oaaacbbbbbbbbecbbbbbbbbeccfo..',
    '..obaacbbbbeeeeaaeeecbbbbeccfo..',
    '..obaacbbbbcaaaaaaaacbbbbeccfo..',
    '..obbbcbbbbbcaaaaaacbbbbbecffo..',
    '..obbbcbbbbbbeaaaacbbbbbbecffo..',
    '..obbbcbbbbbbeaaaacbbbbbbefffo..',
    '..obbbccbbbbbecccccbbbbbeefffo..',
    '...obbbcbbbbbcbbbbcbbbbbefffo...',
    '...obbbccbbbbbbbbbbbbbbeefffo...',
    '....obbbcebbbbbbbbbbbbeefffo....',
    '....occbbeebbbbbbbbbbeeffffo....',
    '.....occcceeebbbbbbeeeffffo.....',
    '......occccceeeeeeeefffffo......',
    '.......occcccccccfffffffo.......',
    '........ooccccffffffffoo........',
    '..........ooffffffffoo..........',
    '............oooooooo............',
    '................................',
    '................................',
  ],
);

export const clover = sprite(
  'sym_clover',
  { o: 'ink', a: 'leaf', b: 'clover', c: 'forest', d: 'pine' },
  [
    '................................',
    '................................',
    '................................',
    '............ooo..ooo............',
    '...........oaaaoobbbo...........',
    '..........oaaaaabbbbco..........',
    '.........oaaaaabbbbbcco.........',
    '.........oaaabbbbbbccco.........',
    '.......oooobbbbbbbcccoooo.......',
    '......oaaabobbbbccccoaaabo......',
    '.....oaaaabbobbbcccoaaaabbo.....',
    '....oaaaabbbooccccooaaaabbbo....',
    '....oaaaabbbo.occo.oaaabbbbo....',
    '....oaaabbbbbooccooaaabbbbbo....',
    '.....obbbbbbcccddaaaabbbbbo.....',
    '.....obbbbcccccddccccccbbbo.....',
    '....obbbbbcccooacoobbbbbbcco....',
    '....obbbbccco.oacooobbbbccco....',
    '....obbcccccooaacbooobccccco....',
    '.....occccccoaaacbbbbocccco.....',
    '......occccoaaabcbbbccocco......',
    '.......ooooaaabbcbbbccooo.......',
    '.........obbbbbbbbbccco.........',
    '.........obbbbbbbbcccco.........',
    '..........obbbbbbcccco..........',
    '...........obbboocccoo..........',
    '............ooo..oooco..........',
    '...................obco.........',
    '...................occo.........',
    '....................occo........',
    '.....................oo.........',
    '................................',
  ],
);

export const grin = sprite(
  'sym_grin',
  { o: 'ink', a: 'lavender', b: 'pinkLilac', c: 'crimson', d: 'flesh', e: 'cerise', f: 'white', g: 'paper', h: 'steel' },
  [
    '................................',
    '................................',
    '................................',
    '.....oo.................oo......',
    '....oabooo...........ooobao.....',
    '.....obbbboo.......oobbbbo......',
    '.o...obbbobbo.....obbbobbo....o.',
    'oco..oaaaobbo.....obbboaao...oco',
    'odcoo.oooaaao.....oaaaooo..oodco',
    'odedcoo..ooo.......ooo...ooddeco',
    'odeeedcoooo..........ooooddeeeco',
    'odefgeedddcooooooooooddddeefgeco',
    'odefgofeeeeddddddddddeeeegofgeco',
    'odefgofgofeeeeeeeeeeeegofgofgeco',
    'odeooofgofgofgofgofgofgofgoooeco',
    'odeoooogofgofgofgofgofgofooooeco',
    'ocegooogofgofgofgofgofgofoooheco',
    '.odghooooogofgofgofgofoooooghco.',
    '.ocehoooooooooooooooooooooogeco.',
    '..oceoghooooocccccccooooghoeco..',
    '...oceghoghoocccccccoghogheco...',
    '....oceeoghoghcghcghoghoeeco....',
    '.....oceeghoghcghcghogheeco.....',
    '......oceeeoghcghcghoeeeco......',
    '.......occeeeeeeeeeeeecco.......',
    '........oocceeeeeeeeccoo........',
    '..........ooccccccccoo..........',
    '............oooooooo............',
    '................................',
    '................................',
    '................................',
    '................................',
  ],
);

export const grape = sprite(
  'sym_grape',
  { o: 'ink', a: 'brick', b: 'mud', c: 'leaf', d: 'forest', e: 'clover', f: 'lavender', g: 'violet', h: 'pinkLilac', i: 'purple' },
  [
    '................................',
    '...............oo....ooooo......',
    '..............oabo.ooccccdoo....',
    '..............oaboocceeeeecdo...',
    '..............oaboceeeeeeedo....',
    '..............ooodeeeeeeeedo....',
    '.........ooo..ofgodeooodddo.....',
    '........ohfgoohfggoohfgooo......',
    '.......ohffgofffggohffggo.......',
    '......offfggofgggofffggiio......',
    '......oggggiogggioggggiiio......',
    '......ooogiooooiiooooiiooo......',
    '.....ohfgoohhfgoohfggoohfgo.....',
    '....ohffgofhfggohffggohffggo....',
    '...offfggoffgggoffggofffggiio...',
    '...oggggioggggioggggoggggiiio...',
    '....oggioooooiooooioooooiiio....',
    '.....oiohhfggohfggohhfggoio.....',
    '......oohffgohhfggohffggoo......',
    '......offgggoffggoffgggiio......',
    '......oggggioogggoooggiiio......',
    '.......oggiofgoooofgoiiio.......',
    '........oiohhfgohhfggoio........',
    '.........offfggohffggio.........',
    '.........offgggofgggiio.........',
    '.........oggggoooogiiio.........',
    '..........oiiohfggoiio..........',
    '...........oohhfggioo...........',
    '............offgggio............',
    '............oggggiio............',
    '............ogggiiio............',
    '.............oiiiio.............',
  ],
);

export const melon = sprite(
  'sym_melon',
  { o: 'ink', a: 'clover', b: 'leaf', c: 'cream', d: 'coral', e: 'forest', f: 'red', g: 'blood', h: 'pine', i: 'vermilion' },
  [
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '..oooooooooooooooooooooooooooo..',
    '.oabcddddddddddddddddddddddcbeo.',
    '.oabcffffffffffffffffffffffcbeo.',
    '.oabbcffffffffffffffffffffcbbeo.',
    '.oaabcffffofffffffffffoffgcbeho.',
    '.oahbcffffofffffoffffioiiicbeeo.',
    '..oabbcfffffffffoffffiiiicbbeo..',
    '..oaabccfffffffffffffiiiccbeeo..',
    '...oaabcfffffofffffofiiicbeho...',
    '...oahbbccfffofffffogiccbbeeo...',
    '....oaabbccffffffffggccbbeeo....',
    '.....oaaabbcccffofcccbbeheo.....',
    '......oahabbbbccocbbbbeeeo......',
    '.......ooaaaebbbbbbeheeoo.......',
    '.........ooaheeeheeeeoo.........',
    '...........oooooooooo...........',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
  ],
);

export const diamond = sprite(
  'sym_diamond',
  { o: 'ink', a: 'ice', b: 'white', c: 'sky', d: 'paper', e: 'blue', f: 'cobalt' },
  [
    '................................',
    '................................',
    '................................',
    '................................',
    '........ooooooooooooooo.........',
    '.......oaaaabbbbbaaaccco........',
    '......oaaaabbbbbbaaaaccco.......',
    '.....oaaaaabbbbbbaaaacccco......',
    '....oaaaaaabaaaaaaaaaccccco.....',
    '...oaaaaaaaaaaaaaaaaaaccccco....',
    '..oaaaaaaaaaaaaaaaaaaacccccco...',
    '.oadddddddddddddccccccccccccco..',
    '.occcceeeecccccceeeeeeffffffffo.',
    '..occcceeeeccccceeeeeffffffffo..',
    '...occceeeeccccceeeeefffffffo...',
    '....occceeeccccceeeeeffffffo....',
    '.....occceeecccceeeeffffffo.....',
    '......occeeecccceeeefffffo......',
    '......occceecccceeeefffffo......',
    '.......occeeeccceeefffffo.......',
    '........occeeccceeeffffo........',
    '.........occeccceeefffo.........',
    '..........oceecceefffo..........',
    '..........occecceefffo..........',
    '...........ocecceeffo...........',
    '............oceceffo............',
    '.............occefo.............',
    '..............oceo..............',
    '...............oo...............',
    '................................',
    '................................',
    '................................',
  ],
);

export const horseshoe = sprite(
  'sym_horseshoe',
  { o: 'ink', a: 'paper', b: 'steel', c: 'lilacGrey', d: 'dusk' },
  [
    '................................',
    '................................',
    '..ooooooooo..........ooooooooo..',
    '.oaaaaaaaaao........oaaaaaaaaao.',
    '.obbbbbbbbbo........obbbbbbbbbo.',
    '..oabbbbbco..........oabbbbbco..',
    '..oabbbbbco..........oabbbbbco..',
    '..oabbbbbco..........oabbbbbco..',
    '..oabbbbbco..........oabbbbbco..',
    '..oabbobbco..........oabbobbco..',
    '..oabbbbbco..........oabbbbbco..',
    '..oabbbbbco..........oabbbbbco..',
    '..oabbbbbco..........oabbbbbco..',
    '..oabbbbbco..........oabbbbbco..',
    '..oabbbbbco..........oabbbbbco..',
    '..oabbobbco..........oabbobbco..',
    '..oabbbbbco..........oabbbbbco..',
    '..oabbbbbco..........oabbbbbco..',
    '..oabbbbbco..........oabbbbbco..',
    '..ocbbbbbco..........oabbbbbco..',
    '...oabbbbbco........oabbbbbco...',
    '...oabbbobbco......oabbobbbco...',
    '...odbbbbbbbcooooooabbbbbbbdo...',
    '....odbbbbbbbaaaaaabbbbbbbdo....',
    '.....odbbbbbbbbbbbbbbbbbbdo.....',
    '......odbbbbbobbbbobbbbbdo......',
    '.......oddbbbbbbbbbbbbddo.......',
    '........ooddbbbbbbbbddoo........',
    '..........ooddddddddoo..........',
    '............oooooooo............',
    '................................',
    '................................',
  ],
);

export const moneybag = sprite(
  'sym_moneybag',
  { o: 'ink', a: 'mauveGrey', b: 'khaki', c: 'sand', d: 'gold', e: 'amber', f: 'cream', g: 'mud', h: 'plumGrey' },
  [
    '................................',
    '................................',
    '.........o............o.........',
    '........oao....oo....oao........',
    '........oaao..obao..oao.........',
    '.........obaoobccaoobao.........',
    '.........obcbbccccbbcao.........',
    '.........oacccccccccao..........',
    '..........oooooooooooo..........',
    '..........odddddddeeeeo.........',
    '..........oeeeeeeeeeeeo.........',
    '...........ooooooooooo..........',
    '.........oofffbbbbcccoo.........',
    '.......ooffffbbbbccccccoo.......',
    '......offfffbbbbbcccccccao......',
    '.....offfffbbbbbccccccccaao.....',
    '....obbffbbbbbbcdcccccccaaao....',
    '....obbbbbbbbbdddddccccaaaao....',
    '...ocbbbbbbbbddgdgggccaaaaaho...',
    '...ocbbbbbbccddgdgccccaaaaaho...',
    '...occccccccccddddcccaaaaaaho...',
    '...occcccccccccgdddcaaaaaahho...',
    '...occccccccccccdgddaaaaahhho...',
    '...occccccccccccdgddgaaahhhho...',
    '....occccccccddddddggaahhhho....',
    '....oacccccccaggdgggaahhhhho....',
    '.....oaaaaaaaaaaagaaahhhhho.....',
    '......oaaaaaaaaaaaahhhhhho......',
    '.......ooaaaaaaaahhhhhhoo.......',
    '.........oohhhhhhhhhhoo.........',
    '...........oooooooooo...........',
    '................................',
  ],
);

export const dice = sprite(
  'sym_dice',
  { o: 'ink', a: 'white', b: 'steel', c: 'paper', d: 'red', e: 'blood', f: 'lilacGrey' },
  [
    '................................',
    '................................',
    '................................',
    '.........oooooooooooooooooooo...',
    '........oaaaaaaaaaaaaaaaaaaabc..',
    '.......oaaaaaaaaaaaaaaaaaaabco..',
    '......oaaaaaaaaadeeaaaaaaabcbo..',
    '.....oaaaaaaaaaeeeaaaaaaabcbbo..',
    '....oaaaaaaaaaaaaaaaaaaabcbbbo..',
    '...oaaaaaaaaaaaaaaaaaaabcbbbbo..',
    '...obbbbbbbbbbbbbbbbbbbcbbbbbo..',
    '...oaaaaaaaaaaaaaaaaaccfbebbbo..',
    '...oaadeeaaaaaaaadeeaccfbebbbo..',
    '...oaaeeeaaaaaaaaeeeaccfbbbbbo..',
    '...oaaeeeaaaaaaaaeeeaccfbbbbbo..',
    '...oaaaaaaaaaaaaaaaaaccfbbbbbo..',
    '...oaaaaaaaaaaaaaaaaaccfbbbbbo..',
    '...oaaaaaaaadeeaaaaaaccfbbbbbo..',
    '...oaaaaaaaaeeeaaaaaaccfbbbbbo..',
    '...oaaaaaaaaeeeaaaaaaccfbbbebo..',
    '...oaaaaaaaaaaaaaaaaaccfbbbebo..',
    '...oaaaaaaaaaaaaaaaaaccfbbbbbo..',
    '...oaadeeaaaaaaaadeeaccfbbbbbo..',
    '...oaaeeeaaaaaaaaeeeaccfbbbbo...',
    '...oaaeeeaaaaaaaaeeeaccfbbbo....',
    '...oaaaaaaaaaaaaaaaaaccfbbo.....',
    '...oaaaaaaaaaaaaaaaaaccfbo......',
    '...occcccccccccccccccccfo.......',
    '...occcccccccccccccccccf........',
    '....ooooooooooooooooooo.........',
    '................................',
    '................................',
  ],
);

export const pearl = sprite(
  'sym_pearl',
  { o: 'ink', a: 'apricot', b: 'salmonPink', c: 'dustyPink', d: 'white', e: 'paper', f: 'pinkLilac', g: 'lavender', h: 'lilacGrey', i: 'cream', j: 'rose' },
  [
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '............o..oo..o............',
    '..........ooaoobboocoo..........',
    '.........oaaaaabbccbbco.........',
    '.......ooocaaoooooobbcooo.......',
    '......oaaccoodeeeffoobbbco......',
    '.....oaaacoddddeefffgobbbco.....',
    '....ooaaaaoddddeefffgobbbcoo....',
    '...oaaaaaoedddeeffffggobcccco...',
    '...oaaaaaoeeeeefffffggoccbbco...',
    '...oaaaaaoeeeefffffgggocbbbco...',
    '..ooccaaaoffffffffggggobbbbcoo..',
    '.oaoccccaofffffffgggghobbbbcoco.',
    '.oaaaaaccoffffffgggghhobbbbbbco.',
    '.oaooooooooooooooooooooooooooco.',
    '..oiiiiiiiiiiiiiiiiiiiiiiiiijo..',
    '..oaaaaaaaaaaaaaaaabbbbbbbbbjo..',
    '..ocaaaaaaaaaaaaaaabbbbbbbbbjo..',
    '...occaaaaaaaaaaaaabbbbbbbjjo...',
    '....oocccaaaaaaaaaabbbbjjjoo....',
    '......oooccccjjjjjjjjjjooo......',
    '.........oooooooooooooo.........',
    '................................',
  ],
);

export const crown = sprite(
  'sym_crown',
  { o: 'ink', a: 'white', b: 'gold', c: 'amber', d: 'lemon', e: 'orange', f: 'brass', g: 'blue', h: 'cobalt', i: 'red', j: 'blood', k: 'clover', l: 'forest', m: 'sky', n: 'coral', p: 'leaf' },
  [
    '................................',
    '................................',
    '..............oooo..............',
    '.............oabbbo.............',
    '...o.........obbbco.........o...',
    '.ooboo.......obbbco.......ooboo.',
    'obabbco......occcco......obabbco',
    'obbbbco.......oooo.......obbbbco',
    'obbbcco.......occo.......obbbcco',
    'occccco......odbcco......occccco',
    '.oocoo.......odbcco.......oocoo.',
    '..ooo.......odbbbcco.......ooo..',
    '..occo.....odbbbbbcco.....occo..',
    '..odcco....odbbbbbcco....odcco..',
    '..odbcco..odbbbbbbbcco..odbcco..',
    '..odbbccoodbbbbbbbbbccoodbbcco..',
    '..odbbbccodbbbbbbbbbccodbbbcco..',
    '..odbbbbbdbbbbbbbbbbbbdbbbbcco..',
    '..odbbbbbbbbbbbbbbbbbbbbbbbcco..',
    '..oooooooooooooooooooooooooooo..',
    '..odddooooddddooooddddooooddeo..',
    '..odfoggghoffoiiijoffokkklofeo..',
    '..odfomgggoffoniiioffopkkkofeo..',
    '..odogggghhooiiiijjookkkklloeo..',
    '..odfogghhoffoiijjoffokkllofeo..',
    '..odfohhhhoffojjjjoffollllofeo..',
    '..oeeeooooeeeeooooeeeeooooeeeo..',
    '...oooooooooooooooooooooooooo...',
    '................................',
    '................................',
    '................................',
    '................................',
  ],
);

export const SYMBOL_SPRITES_B: SpriteDef[] = [
  plum, bell, bar, bar2, bar3, coin, clover, grin, grape, melon, diamond, horseshoe, moneybag, dice, pearl, crown,
];
